import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
	type BarryConversationList,
	getConversationsForUser,
} from '~api/common/barry/barry';
import type { ApiError } from '~types/api';
import { getApiErrorText } from '~utils/getApiErrorText';
import { callErrorToast } from '~utils/toasts';

export const useGetConversationsForUser = (enabled: boolean) => {
	const { barryMessenger } = useFlags();

	return useQuery<unknown, ApiError, BarryConversationList>({
		queryKey: ['getBarryConversationsForUser'],
		queryFn: async () => {
			if (!barryMessenger) {
				return;
			}

			const { data } = await getConversationsForUser({
				limit: 20,
				offset: 0,
			});
			return data as BarryConversationList;
		},
		onError: (error) => {
			callErrorToast({
				content: getApiErrorText(
					error,
					'An error occurred while fetching your conversations with Barry',
				),
			});
			return error;
		},
		enabled,
	});
};
